import React from 'react';

interface TestimonialLayoutProps {
  children: React.ReactNode;
}

export const TestimonialLayout: React.FC<TestimonialLayoutProps> = ({ children }) => {
  return (
    <div>
      {/* Black bar at the top */}
      <div className="h-24 bg-black" />
      
      {/* Testimonial content */}
      {children}
    </div>
  );
};